import SVG from 'react-inlinesvg';
import cx from 'classnames';

import RequiredAsterisk from 'components/common/RequiredAsterisk';
import LibCard, { CardTheme as LibCardTheme } from 'lib/Card';
import {
  BorderTheme,
  BorderThemeStyles,
  CardProps,
  CardTheme,
  CardThemeStyles,
  CardType,
  CardTypeStyles,
  TransparentCardTextStyles,
} from './Card.types';

const cardBase = 'leading-5 py-2.5 px-[15px]';

const Card = ({
  icon,
  header,
  info = '',
  children,
  footer,
  cardType = CardType.REGULAR,
  mandatory = false,
  id = '',
  cardTheme = CardTheme.LIGHT,
  dataTestId = '',
  borderTheme = BorderTheme.BASIC,
}: CardProps): React.ReactElement => {
  const isTransparent = cardType === CardType.TRANSPARENT;
  const isNone = cardType === CardType.NONE;

  return (
    <LibCard theme={LibCardTheme.TRANSPARENT}>
      {header ? (
        <div
          className={cx(
            'flex justify-between items-center',
            CardThemeStyles[cardTheme].cardHeader,
            isTransparent ? 'leading-5 px-0 pt-0 pb-2.5' : cardBase,
          )}
          id={id}
          data-test-id={dataTestId}
        >
          <div className="flex items-center">
            <span className={cx('inline-block align-sub mr-3', CardThemeStyles[cardTheme].cardIcon)}>
              {icon ? <SVG className="w-[18px] h-[18px]" src={icon} /> : null}
            </span>
            <span className="sub-header-lg inline-block">{header}</span>
            {mandatory ? <RequiredAsterisk /> : null}
          </div>
          <div>
            <span className={cx('body-sm', CardThemeStyles[cardTheme].cardInfo)}>{info}</span>
          </div>
        </div>
      ) : null}
      <div
        className={cx('flex flex-col rounded-xl', CardTypeStyles[cardType].card, {
          'mb-5 border': !isTransparent && !isNone,
          'mb-5': isNone,
          [BorderThemeStyles[borderTheme].card]: !isTransparent && !isNone,
          [CardThemeStyles[cardTheme].card]: !isTransparent,
          [TransparentCardTextStyles[cardTheme]]: isTransparent,
        })}
        data-test-id={`${dataTestId}-body`}
      >
        <div className={cx('leading-5 ease duration-300 transition-all', CardTypeStyles[cardType].cardBody)}>
          {children}
        </div>
        {footer ? <div className={cardBase}>{footer}</div> : null}
      </div>
    </LibCard>
  );
};

export default Card;
